const LoyaltyBadgeModule = () => import('./LoyaltyBadgeModule.vue')
const BadgesIndex = () => import('./views/BadgesIndex.vue')

export const loyaltyBadgeRoute = {
  path: '/loyalty',
  component: LoyaltyBadgeModule,
  meta: {
    title: 'LoyaltyBadges',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'badges',
      name: 'loyaltyBadges',
      meta: {
        permission: 'loyalty_badge.view',
      },
      component: BadgesIndex,
    },
  ],
}
